import {
  TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_ID,
  TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_SHORT_NAME,
  TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_ID,
  TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_SHORT_NAME,
  TEMPLATE_PRICE_LIST_TYPE_MARKETING_ID,
  TEMPLATE_PRICE_LIST_TYPE_MARKETING_SHORT_NAME,
} from '../../../../constants/crm/TemplatePriceListTypeConstants';
import { NUMBER_DATE_TIME_PATTERN } from '../../../../procedures/date-format';
import column from '../../../abstract/column';
import vars from '../../../abstract/vars';
import actions from './actions';
import api from './api';

const templatepricelisttypeMap = new Map();
templatepricelisttypeMap.set(TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_ID, TEMPLATE_PRICE_LIST_TYPE_ENTREPRENEUR_SHORT_NAME);
templatepricelisttypeMap.set(TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_ID, TEMPLATE_PRICE_LIST_TYPE_ACCOUNTING_SHORT_NAME);
templatepricelisttypeMap.set(TEMPLATE_PRICE_LIST_TYPE_MARKETING_ID, TEMPLATE_PRICE_LIST_TYPE_MARKETING_SHORT_NAME);

export default {
  api,
  actions,
  sidebarData: {
    id: column({
      label: 'Identyfikator',
      size: 100
    }),
  },
  columns: {
    name: column({
      label: 'Nazwa',
    }),
    templatepricelisttype: column({
      label: 'Typ',
      component: 'value-status-tooltips',
      items: ({ item }) => [
        {
          label: `${ templatepricelisttypeMap.get(item?.templatepricelisttype?.id) }`,
          tooltip: `${ item?.templatepricelisttype?.name }`,
        },
      ],
    }),
    is_base: column({
      label: '',
      component: 'ValueIconTooltip',
      iconTooltipConfig: ({ item }) => {
        return {
          render: (item) => {
            return !!item?.is_base;
          },
          tooltip: () => `Bazowy cennik`,
          icon: 'info',
        };
      },
    }),
    created_at: column({
      label: 'Data ostatniej modyfikacji',
      dateFormat: NUMBER_DATE_TIME_PATTERN,
    }),
  },

  vars: vars({
    noItemsText: 'Brak szablonów cenników',
    sidebarLabel: 'Podgląd szablonu cennika',
    softDelete: {
      title: 'Usunięcie cennika',
      text: (item) => `Czy na pewno chcesz usunąć cennik ${ item.name }?`,
      successText: 'Dokument został usunięty.',
    },
  }),

  topRightActions: {
    create: {
      label: 'Dodaj cennik',
      icon: 'icon-plus',
      handle: async ({ component }) => {
        component.$emit('createNewPriceListPopupOpen', true);
        return true;
      },
    },
  },
};
